export default {
  SET_CURRENT_ROUTE(state, payload) {
    state.currentRoute = payload
  },
  SET_MENU_COLLAPSED(state, value) {
    state.menuCollapsed = value
  },
  SET_FULL_SCREEN(state, value) {
    state.fullScreen = value
  },
  SET_DARK_MODE(state, value) {
    state.darkMode = value
  },
  SET_SIDEBAR_VISIBLE(state, value) {
    state.sidebarVisible = value
  },
  SET_QUICK_SEARCH_VISIBLE(state, value) {
    state.quickSearchVisible = value
  }
}
